export default theme => ({
  textField: {
    marginTop: '0.4em',
    marginBottom: 0,
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    width: 500,
  },
})
